export const WhiteMailLoader = () => {
  return () => {
    return false;
  };
};
